export const SESSION_EXPIRED_EVENT = 'session-expired'
export const USER_ACTIVITY_AFTER_IDLE_EVENT = 'user-activity-after-idle'
